/* @flow strict */

import 'normalize.css';
import 'reset-css';
import './styles.scss';
import './styles.less';
//
import * as React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import Entry from './Entry';
import i18n from './i18n';
import extractScriptData from './utils/extractScriptData';

const root = document.getElementById('react-app');

const profile = extractScriptData('profile');

ReactDOM.render(
  <Router
    getUserConfirmation={() => {
      /* Empty callback to block the default browser prompt */
    }}>
    <Entry renderer={process.env.RENDERER} i18n={i18n} profile={profile} />
  </Router>,
  root
);